<template lang="html">
  <RowContent 
    :model="model" 
    :header="header" 
    :cell="cell" 
    :statuses="statuses" 
    :loadingStatus="loadingStatus" 
    :fullName="[candidate.name, candidate.surname].join(' ')"
    @statusChange="$emit('statusChange', $event)"
  />
</template>

<script>
import RowContent from './RowContent.vue'

export default {
  name: 'process-responses-row',

  props: {
    model: Object,
    header: Object,
    cell: Object,
    statuses: Array,
    loadingStatus: Boolean,
  },

  components: {
    RowContent
  },

  computed: {
    candidate () {
      return this.model.candidate
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
